import { useUserProvider } from "./provider";
import { Image } from "../reusables";
import "./index.css";
import {
  Box,
  Button,
  IconButton,
  useStyleConfig,
  VStack,
} from "@chakra-ui/react";
import { TbPhotoEdit } from "react-icons/tb";
import useUploader from "../../hooks/useUploader";
import useImageCompressor from "../../hooks/useImageCompressor";
import { useFirebase } from "../../wrappers/firebase";
import useProfile from "../../hooks/data/useProfile";
import { forwardRef } from "react";
import { BiUser } from "react-icons/bi";

/**
 * @typedef {import("@chakra-ui/react").BoxProps} BoxProps
 */
/**
 * @type {React.ForwardRefExoticComponent<BoxProps & React.RefAttributes<HTMLImageElement>>}
 */
const _Image = forwardRef((props, ref) => {
  const user = useUserProvider();
  const { openDialog } = useUploader({
    allowedType: "image",
    onFilesChanged: compressCoverPhoto,
  });
  const { compress } = useImageCompressor();
  const { uploadFile } = useFirebase();
  const { updateProfile } = useProfile();

  const _coverPhotoFilename =
    user.coverPhotoFilename ||
    user.coverPhoto?.[user.coverPhoto?.length - 1]?.fileName;

  async function compressCoverPhoto(files) {
    const coverPhoto = files[0];
    const _compressed = await compress(coverPhoto);

    handleChange({ coverPhoto: _compressed });
  }

  async function handleChange(values) {
    await Promise.all(
      values.coverPhoto.map(({ blob, fileName }) =>
        uploadFile({
          path: `photos/${user.id}/cover/`,
          file: blob,
          useUidInName: false,
          fileName,
        })
      )
    );

    // _cleaned now excludes the 'blob' property from each item in the coverPhoto array
    const _cleaned = values.coverPhoto.map(({ blob, ...rest }) => rest);
    const _updated = updateProfile({
      uid: user.id,
      data: { coverPhoto: _cleaned },
    });
  }

  const styles = useStyleConfig("Button", { variant: "nav" });

  return (
    <Box ref={ref} borderRadius={"full"} pos="relative" {...props}>
      {user.allowEdit && (
        <Box
          pos="absolute"
          top="0"
          bottom="0"
          left="0"
          right="0"
          zIndex="2"
          opacity={_coverPhotoFilename ? 0 : 1}
          _hover={{
            opacity: 1,
          }}
        >
          <IconButton
            w="full"
            h="full"
            borderRadius={"full"}
            border="1px dashed"
            borderColor={"gray.600"}
            variant={"nav"}
            icon={<TbPhotoEdit size={20} />}
            cursor={"pointer"}
            onClick={openDialog}
          />
        </Box>
      )}
      {_coverPhotoFilename ? (
        <Image
          h="full"
          w="full"
          borderRadius={"full"}
          firebaseStoragePath={
            user?.id ? `photos/${user?.id}/cover/${_coverPhotoFilename}` : null
          }
          {...props}
        />
      ) : (
        <VStack
          transition={"none"}
          w="full"
          h="full"
          // bg="transparent"
          justify={"center"}
          align={"center"}
          // _hover={{
          //   bg: "#313134",
          // }}
          borderRadius={"full"}
          {...props}
        >
          <BiUser size={19} />
        </VStack>
      )}
    </Box>
  );
});

export default _Image;
